<template>
  <div class='row' :class='{ "h-row-around-inputBox": cellFlag, "h-row-inputBox": !cellFlag }'>
    <div class='col-sm-6' v-if='cellFlag'>
      <div class='h-col-inputBox'>
        <div class='h-borderBox height-500'>
          <div class='h-borderTree-top'><span class="h-red-code">* </span>{{$t('Track.measuringObject')}}:</div>
          <div class='h-borderTree-content'>
            <CellTree ref='neTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true'></CellTree>
          </div>
        </div>
      </div>
    </div>
    <div :class='tabRowClassObject'>
      <ParseForm :formParam='formParam' :defaultData='defaultData' :cellFlag='cellFlag' :formId="formParam.name + 'Form'" ref='bus' ></ParseForm>
    </div>
  </div>
</template>
<script>
import ParseForm from '../util/parseForm/ParseForm';
import CellTree from './CellTree';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'BaseBusiness',
  components: {
    ParseForm,
    CellTree
  },
  props: {
    formParam: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    },
    defaultData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      cellFlag: false
    };
  },
  computed: {
    tabRowClassObject() {
      return this.cellFlag ? 'col-sm-6' : '';
    }
  },
  created() {
    if (JSON.stringify(this.defaultData) !== '{}') {
      this.cellFlag = false;
    } else {
      this.cellFlag = this.formParam.param ? this.formParam.param.some(item => item.name === 'cellsId') : false;
    }
  },
  updated() {
    if (JSON.stringify(this.defaultData) !== '{}') {
      this.cellFlag = false;
    } else {
      this.cellFlag = this.formParam.param ? this.formParam.param.some(item => item.name === 'cellsId') : false;
    }
  },
  methods: {
    getDatas() {
      const params = {};
      this.formParam.param.forEach(item => {
        switch (item.type) {
          case 'formCheckBox':
            // item.value.forEach((value) => {
            //   params[value] = item.datasource[item.datasource.findIndex(v => v.realName === value)].value;
            // });
            item.value.forEach((value, key) => {
              params[key] = value;
            })
            break;
          case 'formTime':
            params[item.name] = new Date(item.value).getTime() || '';
            break;
          default:
            params[item.name] = item.value || '';
        }
      });
      if (this.cellFlag) {
        const checkIdList = this.$refs.neTree.getCheckNodeList();
        if (checkIdList.length < 1) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.pleaseSelectMeasuringObject')});
          return false;
        }
        params.cellsId = `[${checkIdList.toString()}]`;
        return params;
      }
      return params;
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    }
  }

};
</script>
